export default () => window?.nodeModules?.unusedFilename;
